import axios from 'axios';
// import { Message } from 'element-ui';
import store from '../store';


axios.withCredentials = true;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.withCredentials = 'true';
axios.defaults.credentials = 'include';
axios.defaults.crossDomain = true;
axios.defaults.transformRequest = (data) => {
  let ret = '';
  if (data) {
    Object.keys(data).forEach((it) => {
      ret += `${encodeURIComponent(it)}=${encodeURIComponent(data[it])}&`;
    });
  }
  return ret;
};


axios.defaults.retry = 4;
axios.defaults.retryDelay = 1000;

axios.interceptors.response.use(undefined, (err) => {
  const { config } = err;
  // If config does not exist or the retry option is not set, reject
  if (!config || !config.retry) return Promise.reject(err);

  // Set the variable for keeping track of the retry count
  config.__retryCount = config.__retryCount || 0;

  // Check if we've maxed out the total number of retries
  if (config.__retryCount >= config.retry) {
    // Reject with the error
    return Promise.reject(err);
  }

  // Increase the retry count
  config.__retryCount += 1;

  // Create new promise to handle exponential backoff
  const backoff = new Promise(((resolve) => {
    setTimeout(() => {
      resolve();
    }, config.retryDelay || 1);
  }));

  // Return the promise in which recalls axios to retry the request
  return backoff.then(() => axios(config));
});
// create an axios instance
const service = axios.create({
  baseURL: '/', // api的base_url
  timeout: 20000, // request timeout
  credentials: 'include',
});
// request interceptor
service.interceptors.request.use((config) => {
  const configs = config;
  if (store.getters.token) {
    configs.headers['X-TOKEN'] = store.getters.token;
  }
  return configs;
}, (error) => {
  // Do something with request error
  // for debug
  Promise.reject(error);
});

// respone interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.error === '9999') { // 401 token失效
      store.dispatch('FedLogOut').then(() => {
        const redirect = window.location.href;
        window.location.href = `${window.location.origin}/#/login?redirect=${redirect}`;
      });
      return Promise.reject(new Error(res.msg || 'error'));
    }
    if (res.error !== 0) {
      this.$toasted.show(res.msg, {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 5000,
      });
      return Promise.reject(new Error(res.msg || 'error'));
    }
    return res.data;
  },
  (error) => Promise.reject(error)
  /* Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000,
    }); */

  ,
);

export default service;
